import React, { useEffect, useRef } from 'react';
import { useGetLocationSuggestionsQuery } from '../../api/jobCreateApiSlice';
import RoundLoader from '../../../../components/Loader/RoundLoader';
import styles from './SuggestionBox.module.scss';

function SuggestionBox({ keyword, form, name = "locations", visibilty, setVisibility, onSuggestionSelect }) {
    const { data, isLoading, isFetching } = useGetLocationSuggestionsQuery(keyword);
    const suggestionRef = useRef(null);
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;

        const handleSuggestionBoxVisibility = (e) => {
            if (
                suggestionRef.current &&
                visibilty &&
                !suggestionRef.current.contains(e.target)
            ) {
                setVisibility(false);
            }
        };

        document.addEventListener('click', handleSuggestionBoxVisibility);

        return () => {
            isMounted.current = false;
            document.removeEventListener('click', handleSuggestionBoxVisibility);
        };
    }, [visibilty, setVisibility]);

    const handleClick = (suggestion) => {
        if (isMounted.current) {
            onSuggestionSelect({ id: suggestion.id, name: suggestion.name });
            setVisibility(false);
            if (name === "location") {
                form.setFieldValue(name, suggestion.name);
            }
        }
    };

    if ((isLoading || isFetching) && visibilty) {
        return <RoundLoader className={styles.whiteLoader} />;
    }

    return (data != undefined && data.length > 0 && visibilty) ? (
        <ul className={styles.suggestionBox} ref={suggestionRef}>
            {data.map((item, index) => (
                <li
                    key={index}
                    onClick={() => handleClick(item)}
                >
                    {item.name}
                </li>
            ))}
        </ul>
    ) : null;
}

export default SuggestionBox;
